﻿

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
	clearTimeout(timer);
	timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}
function setStuck() {
  let limit = 10;
  let force = window.scrollY > limit;
  element.classList.toggle('stuck', force);
}
const debouncedScroll = debounce(() => setStuck(), 50);

const element = document.querySelector('#custom-middle-navbar');
if (element) {
  window.addEventListener('scroll', debouncedScroll)
}